import React from "react";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CourseInformation from "../../Components/CourseInformation/CourseInformation.jsx";
import CourseIntroduction from "../../Components/CourseIntroduction/CourseIntroduction.jsx";
import "./Course.css";
import RelatedCourses from "../../Components/RelatedCourses/RelatedCourses";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration.js";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet-async";

export default function Course() {
    const param = useParams("title");
    const [courseData, setCourseData] = useState([]);
    const [courseList, setCourseList] = useState([]);

    useEffect(() => {
        axiosConfig
            .get("api/courses?page=1&pageSize=25&price=-1")
            .then((res) => {
                setCourseList(res.data.data);
            });
        axiosConfig
            .get(
                "api/Courses/" +
                param.title +
                "?userId=" +
                localStorage.getItem("userId")
            )
            .then((res) => {
                setCourseData(res.data);
            });
        axiosConfig.get("api/Comments/" + courseData.id).then((res) => { });
    }, [param]);

    return (
        <>
            <Helmet>
                <title>سه نیک |{courseData?.title ?? `در حال بارگذاری`}</title>
                <meta
                    name="description"
                    content={courseData.description?.slice(0, 160) || 'مشاهده جزئیات '}
                />
            </Helmet>
            <div className="Course-wrapper">
                <Container>
                    <CourseIntroduction courseData={courseData} />
                </Container>
                <CourseInformation courseData={courseData} />
                <Container>
                    <RelatedCourses courseList={courseList} />
                </Container>
            </div>
            <ToastContainer />

        </>
    );
}
